import { ISbStoryData } from 'storyblok-js-client'

import { Seo } from 'components/Seo'
import { Layout } from 'components/blocks/layout/Layout'
import { DynamicBlock } from 'components/blocks/sections/DynamicBlock'
import { OpenEveningStoryblok } from 'lib/storyblok/types'

type Props = {
  story: ISbStoryData<OpenEveningStoryblok>
}

export const OpenEveningPage = ({ story }: Props): JSX.Element => {
  return (
    <Layout>
      <Seo story={story} />

      {story.content.body &&
        story.content.body.map((block) => (
          <DynamicBlock key={block._uid} block={block} />
        ))}
    </Layout>
  )
}
